<template>
  <div
    class="settings-container"
    @click="handleItemClick(item)"
    :style="{
      justifyContent: item.label === 'Units I like' ? 'flex-end' : 'flex-start',
      gap: item.label === 'Units I like' ? '50px' : '25px',
    }"
  >
    <div class="setting-logo-lavel">
      <img :src="item.icon" class="settings-icon" loading="eager" alt="" />
      <div class="setting-label-container">
        <div class="setting-label">{{ item.label }}</div>
        <div class="setting-label-info">
          {{ item.info }}
        </div>
      </div>
    </div>
    <div
      v-if="item.label === 'Units I like'"
      class="toggle"
      :class="{ active: switchOn }"
      @click="toggleSwitch"
    >
      <div class="toggle-child"></div>
      <div class="toggle-item"></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const switchOn = ref(false);
const clickedMenuItemEmit = defineEmits(["clickedMenuItem"]);

defineProps({
  item: Object,
});

function handleItemClick() {
  clickedMenuItemEmit("clickedMenuItem");
}

const toggleSwitch = () => {
  switchOn.value = !switchOn.value;
};
</script>

<style scoped>
.settings-container {
  align-self: stretch;
  border-radius: var(--br-9xs) 0px 0px var(--br-9xs);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 25px;

  .setting-logo-lavel {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: var(--gap-xl);

    .setting-label-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding: var(--padding-12xs) 0px;
      gap: 5px;

      .setting-label {
        position: relative;
        letter-spacing: 0.01em;
        line-height: 27px;
        font-weight: 600;
        color: var(--black-default);
      }

      .setting-label-info {
        position: relative;
        font-size: var(--paragraph-primary-regular-regular-size);
        line-height: 22px;
        color: var(--black-medium);
      }
    }
  }
}

.settings-icon {
  height: 30px;
  width: 30px;
  position: relative;
  border-radius: var(--br-9xs);
  overflow: hidden;
  flex-shrink: 0;
}

.toggle-child {
  position: absolute;
  top: calc(50% - 2px);
  left: calc(50% - 4px);
  border-radius: 1px;
  border: 2px solid var(--gray-medium);
  box-sizing: border-box;
  width: 28px;
  height: 4px;
  overflow: hidden;
}

.toggle-item {
  position: absolute;
  top: 18px;
  left: 20px;
  border-radius: 10px;
  background-color: var(--white-light);
  border: 4px solid var(--black-default);
  box-sizing: border-box;
  width: 12px;
  height: 12px;
  overflow: hidden;
  z-index: 1;
}

.toggle {
  height: 48px;
  width: 48px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
}

.toggle.active .toggle-child {
  border: 2px solid var(--primary-accent-light);
}

.toggle.active .toggle-item {
  left: 36px;
  border: 4px solid var(--primary-accent-base);
  background-color: var(--primary-accent-base);
}
</style>
